/* global axios */
import ApiClient from './ApiClient';
import { requestConfig } from './lais/httpHelpers';

class SalesTransactionPartyDocumentsAPI extends ApiClient {
  constructor() {
    super('sales_transactions', { accountScoped: true });
  }

  path(transactionId, partyId, suffix = '') {
    return `${this.url}/${transactionId}/parties/${partyId}/documents${suffix}`;
  }

  list(transactionId, partyId) {
    return axios.get(this.path(transactionId, partyId), requestConfig());
  }

  upload(transactionId, partyId, file, onUploadProgress, documentTypes = []) {
    const formData = new FormData();
    formData.append('file', file);
    documentTypes.forEach((documentType, index) => {
      Object.entries(documentType || {}).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          formData.append(`document_types[${index}][${key}]`, value);
        }
      });
    });

    const config = requestConfig();
    return axios.post(this.path(transactionId, partyId), formData, {
      ...config,
      headers: {
        ...config.headers,
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress,
    });
  }

  update(transactionId, partyId, documentId, documentTypes = []) {
    const payload = { document_types: documentTypes };
    return axios.patch(
      this.path(transactionId, partyId, `/${documentId}`),
      payload,
      requestConfig()
    );
  }

  signedUrl(transactionId, partyId, documentId) {
    return axios.post(
      this.path(transactionId, partyId, `/${documentId}/signed_url`),
      {},
      requestConfig()
    );
  }

  remove(transactionId, partyId, documentId) {
    return axios.delete(
      this.path(transactionId, partyId, `/${documentId}`),
      requestConfig()
    );
  }
}

export default new SalesTransactionPartyDocumentsAPI();
